

import { useEffect, useMemo, useState } from "react";
import Card from "react-bootstrap/Card";
import { RBTable } from "@pallassystems/react-bootstrap-table";

import Breadcrumb from "app/components/Breadcrumb";
import { axios } from "fake-db/mock";

export default function RemainingLeave() {
  const [users, setUsers] = useState([]);

  const columns = useMemo(
    () => [
      { accessorKey: "leaveType", header: "Leave Type", searchable: true },
      { accessorKey: "allocatedDay", header: "Allocated Day", searchable: true },
      { accessorKey: "remaining", header: "Remaining", searchable: true }
    ],
    []
  );

  useEffect(() => {
  axios
    .get("/api/user/all")
    .then((res) => {
      console.log("Remaining Leave API Response:", res.data);

      const list = (res.data || []).map((item, index) => ({
        leaveType: ["Casual Leave", "Sick Leave", "Earned Leave"][index] || "Other",
        allocatedDay: [12, 10, 15][index] || 5,
        remaining: [8, 5, 12][index] || 0,
      }));

      setUsers(list);
    })
    .catch((err) => {
      console.error("Remaining Leave API Error:", err);

      // Fallback static data
      setUsers([
        { leaveType: "Casual Leave", allocatedDay: 12, remaining: 8 },
        { leaveType: "Sick Leave", allocatedDay: 10, remaining: 5 },
        { leaveType: "Earned Leave", allocatedDay: 15, remaining: 12 },
      ]);
    });
}, []);


  return (
    <section>
      <Breadcrumb
        routeSegments={[
          { name: "Dashboard", path: "/" },
          { name: "Employees", path: "/employees" },
          { name: "Remaining Leave" }
        ]}
      />

      <Card body>
        <Card.Title>Remaining Leave</Card.Title>

        {users.length > 0 && (
          <RBTable
  data={users}
  columns={columns}
  varient="primary"
  footer={{ enablePagination: true }}
  toolbar={{
    enableFilters: true,
    enableGlobalFilter: true,
    enableDensityToggle: true,
    enableExportButton: true
  }}
/>
           
        )}
      </Card>
    </section>
  );
}
